import type { OwnershipMapping } from 'api/data/ownership/models/OwnershipMapping';
import { useApi } from 'api/useApi';
import { ENV_VARS } from 'app/config/environment-vars';

const OWNERSHIP_ERROR_KEY = 'OwnershipApiClient';

export const useOwnershipApi = () => {
  const fetchFunction = useApi(`${ENV_VARS.DATA_URL}/api/ownership/mappings`, OWNERSHIP_ERROR_KEY);

  const getOwnershipMapping = (projectId: string) => fetchFunction<OwnershipMapping>(`/projects/${projectId}`);

  return {
    getOwnershipMapping
  };
};
